import service from './index'

const resource = service.resource('race-resumes{/id}')
const resourceRaceResumesByRace = service.resource('race-resumes/by-race{/id}')

export default {
  get (id) {
    return resource.get({id: id})
  },
  create (raceResume) {
    return resource.save({}, raceResume)
  },
  update (raceResume) {
    return resource.update(raceResume)
  },
  getRaceResumesByRace (id) {
    return resourceRaceResumesByRace.get({id: id})
  },
  
}



// WEBPACK FOOTER //
// ./src/services/raceResume.js